export default __webpack_public_path__ + "static/media/mountain-left.a648094c.svg";